import { render, staticRenderFns } from "./LeadCategory.vue?vue&type=template&id=64979020"
import script from "./LeadCategory.vue?vue&type=script&lang=js"
export * from "./LeadCategory.vue?vue&type=script&lang=js"
import style0 from "./LeadCategory.vue?vue&type=style&index=0&id=64979020&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports